import * as React from "react";
function XxlIcon() {
    return React.createElement("path", { d: "M18.9577 35.0844L8.43079 24.5576L10.0615 22.9461L18.9577 31.8422L37.9077 12.873L39.5384 14.5037L18.9577 35.0844Z", fill: "currentColor" });
}
export default XxlIcon;
//# sourceMappingURL=Xxl.js.map